"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_LIMIT_IN_DAYS = exports.LEADER_INSTANCE_NODE = exports.EXTERNAL_EMAIL = exports.ASTERISK = exports.SAML_AUTH_STATE_PREFIX = exports.FASPEX_CLIENT_BLAST_BA_SECRET = exports.FASPEX_CLIENT_BLAST_BA = exports.FASPEX_CLIENT_BLAST = exports.FASPEX_CLIENT_ADMIN = exports.EONE_USERS = exports.SamlProvider = exports.INTERACTIONS_BLACKLIST = exports.titleSortField = exports.sizeSortField = exports.senderNameSortField = exports.expirationDateSortField = exports.creationDateSortField = exports.VALIDATE_EMAIL_REGEX = exports.EMAIL_REGEX = exports.TEST_FASPEX_URL = exports.PROD_FASPEX_URL = exports.FASPEX_V5_POC_URL = exports.PROD_HOST = exports.UAT_HOST = exports.QA_HOST = exports.CI_HOST = exports.DEV_HOST = exports.PROFILE_FIELD_TITLE = exports.PROFILE_FIELD_LOCATION = exports.PROFILE_FIELD_COMPANY = exports.APP_PORT = void 0;
exports.APP_PORT = process.env.PORT || 8888;
// Faspex user profile fields
exports.PROFILE_FIELD_COMPANY = 'Company';
exports.PROFILE_FIELD_LOCATION = 'Location';
exports.PROFILE_FIELD_TITLE = 'Title';
// Blast environment domains
exports.DEV_HOST = 'https://localhost';
exports.CI_HOST = 'https://ci-blast.hasbro.com';
exports.QA_HOST = 'https://qa-blast.hasbro.com';
exports.UAT_HOST = 'https://uat-blast.hasbro.com';
exports.PROD_HOST = 'https://blast.hasbro.com';
// Faspex environment domains
exports.FASPEX_V5_POC_URL = 'https://usnpdaspfast11.na.hasbro.com'; // TODO-v5: remove when no longer needed
exports.PROD_FASPEX_URL = 'https://faspex.hasbro.com';
exports.TEST_FASPEX_URL = 'https://test-faspex.hasbro.com'; // Test environments: dev, ci, qa & uat
/**
 * Expression used to determine if a string is a valid email format
 */
exports.EMAIL_REGEX = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
/**
 * Expression used to determine if a user is internal or external
 */
// export const VALIDATE_EMAIL_REGEX = /^[\'a-z0-9._%+-]+@((c|na|ap|wz|eu|partners).)?(hasbro|wizards|hasbrosa|studiosprod|hasbrotoysandgames|backflipstudios)\.(tv|com(\.(hk|my|sg|tr|tw|au))?|(co\.(uk|kr))|at|be|ch|de|dk|es|fi|fr|gr|ie|it|jp|nl|no|pt|se)/;
exports.VALIDATE_EMAIL_REGEX = /^.+@((c|na|ap|wz|eu|partners).)?(hasbro|wizards|hasbrosa|studiosprod|hasbrotoysandgames|atomicarcade|skeletonkeystudio)\.(tv|co|com(\.(hk|my|sg|tr|tw|au))?|(co\.(uk|kr))|at|be|ch|de|dk|es|fi|fr|gr|ie|it|jp|nl|no|pt|se)/;
// Sort fields for search
exports.creationDateSortField = 'creationDate';
exports.expirationDateSortField = 'expirationDate';
exports.senderNameSortField = 'sender.user.firstName';
exports.sizeSortField = 'totalBytes';
exports.titleSortField = 'title';
// List of blacklisted email/users from interactions
exports.INTERACTIONS_BLACKLIST = [
    'csp'
];
/**
 * These values map to the SAML configuration indices
 */
var SamlProvider;
(function (SamlProvider) {
    SamlProvider[SamlProvider["UNKNOWN"] = 0] = "UNKNOWN";
    SamlProvider[SamlProvider["HASBRO"] = 1] = "HASBRO";
    SamlProvider[SamlProvider["EONE"] = 2] = "EONE";
})(SamlProvider = exports.SamlProvider || (exports.SamlProvider = {}));
exports.EONE_USERS = /^.*@(entonegroup|filmsseville|sierra-affinity|eone|renegade83|whizzkid)\.(com|co)$/i;
/* Faspex V5 constants */
exports.FASPEX_CLIENT_ADMIN = 'b24e6d5f-3b2a-413b-90ef-dd4902c44cf8'; // TODO-V5: move to configs, since they'll be different in test vs prod
exports.FASPEX_CLIENT_BLAST = '00a2de40-b572-40fb-acf3-bb23a4694a24'; // TODO-V5: move to configs, since they'll be different in test vs prod
exports.FASPEX_CLIENT_BLAST_BA = '6bc26874-5e41-45a1-96b0-d5a4917bb23b'; // TODO-V5: move to configs, since they'll be different in test vs prod
exports.FASPEX_CLIENT_BLAST_BA_SECRET = '252UDvhMJ8Uidwl0K_CZSi1A4fO15Mo15kJC6A_vl8l2VZoY8MGD07Ixpaf3f2JFGkz6-PLhgkP0JLjqv5JHhwvfp9PlVhp8'; // TODO-V5: replace by api retrieval
exports.SAML_AUTH_STATE_PREFIX = 'blast|redirect=';
/* Miscellaneous constants */
exports.ASTERISK = '*'; // added workgroup prefix
exports.EXTERNAL_EMAIL = '(external email)'; // default "last name" for un-registered users
exports.LEADER_INSTANCE_NODE = '0'; // default node id for the "leader node"
exports.SEARCH_LIMIT_IN_DAYS = 90; // default number of days packages will be viewable in Blast
